import styled from "@emotion/styled/macro";

export const VscTitle: React.FC<{ title: string, subtitle: string }> = ({title, subtitle}) => {

    return <div className={"vsc-title"}>
        <h1>{title}</h1>
        <p className={"subtitle1"}>{subtitle}</p>
    </div>
}